import { ref } from 'vue'
import { useSetting } from '@/composables/use-setting'

const { getClientInfo } = useSetting();
const clientInfo = getClientInfo();

const wsLocaleLang = ref(null)
const wsI18nLangStore = {
  'ZH': { "name": "Chinese", "short": "zh", "key": "ZH", "desc": "中文" },
  'EN': { "name": "English", "short": "en", "key": "EN", "desc": "英语" },
  'TR': { "name": "Turkey", "short": "tr", "key": "TR", "desc": "土耳其语" },
  'SL': { "name": "slovenščina", "short": "sl", "key": "SL", "desc": "斯洛文尼亚语" },
  'SK': { "name": "slovenčina", "short": "sk", "key": "SK", "desc": "斯洛伐克语" },
  'LT': { "name": "kalba", "short": "lt", "key": "LT", "desc": "立陶宛语" },
  'ET': { "name": "Eesti keel", "short": "et", "key": "ET", "desc": "爱沙尼亚语" },
  'LV': { "name": "latviešu valoda", "short": "lv", "key": "LV", "desc": "拉脱维亚语" },
  'EL': { "name": "Ελληνικά", "short": "el", "key": "EL", "desc": "希腊语" },
  'IT': { "name": "Italian", "short": "it", "key": "IT", "desc": "意大利语" },
  'ES': { "name": "Español", "short": "es", "key": "ES", "desc": "西班牙语" },
  'PT': { "name": "Português", "short": "pt", "key": "PT", "desc": "葡萄牙语" },
  'MT': { "name": "Lingwa Maltija", "short": "mt", "key": "MT", "desc": "马耳他语" },
  'FR': { "name": "Français", "short": "fr", "key": "FR", "desc": "法语" },
  'DE': { "name": "German", "short": "de", "key": "DE", "desc": "德语" },
  'NL': { "name": "Nederlands", "short": "nl", "key": "NL", "desc": "荷兰语" },
  'FI': { "name": "Suomi", "short": "fi", "key": "FI", "desc": "芬兰语" },
  'SV': { "name": "Svenska", "short": "sv", "key": "SV", "desc": "瑞典语" },
  'DA': { "name": "Dansk", "short": "da", "key": "DA", "desc": "丹麦语" },
  'NO': { "name": "Norsk", "short": "no", "key": "NO", "desc": "挪威语" },
  'IS': { "name": "íslenska", "short": "is", "key": "IS", "desc": "冰岛语" },
  'PL': { "name": "Polish", "short": "pl", "key": "PL", "desc": "波兰语" },
  'RU': { "name": "Russian", "short": "ru", "key": "RU", "desc": "俄语" },

  'CA': { "name": "Catalan", "short": "ca", "key": "CA", "desc": "加泰罗尼亚语" },
  'RO': { "name": "Romanian (official)", "short": "ro", "key": "RO", "desc": "罗马尼亚语（官方）" },
  'BG': { "name": "Bulgarian", "short": "bg", "key": "BG", "desc": "保加利亚语" },
  'HU': { "name": "Hungarian (Magyar)", "short": "hu", "key": "HU", "desc": "匈牙利语（马扎尔语）" },
  'LB': { "name": "Luxembourgish", "short": "lb", "key": "LB", "desc": "卢森堡语" },
  'CS': { "name": "Czech", "short": "cs", "key": "CS", "desc": "捷克语" },
  'HR': { "name": "Croatian", "short": "hr", "key": "HR", "desc": "克罗地亚语" },
};

const localstorageKey = 'wsLangKey'
const updateLanguagestorageKey = 'wsLangUpdate'
/**
 * 设置
 * @returns
 */
export const wsLangSetting = () => {
  /**
   * 获取
   * @returns
   */
  const init = () => {
    const localKey = localStorage.getItem(localstorageKey)
    if (localKey) {
      updateWsLangByKey(localKey)
    } else {
      updateWsLangByKey(clientInfo.language)
    }
  }

  const updateWsLangByKey = (key, isUpdateRomote = false) => {
    const bigKey = key.toUpperCase()
    const lang = wsI18nLangStore[bigKey]
    if (lang) {
      wsLocaleLang.value = lang
      localStorage.setItem(localstorageKey, bigKey)
      if (isUpdateRomote) {
        localStorage.setItem(updateLanguagestorageKey, '1')
      }
    } else {
      wsLocaleLang.value = wsI18nLangStore['EN']
    }
  }

  const clear = () => {
    localStorage.setItem(localstorageKey, '')
    // updateWsLangByKey(clientInfo.language)
  }
  return {
    init,
    wsI18nLangStore,
    updateWsLangByKey,
    wsLocaleLang,
    clear,
    updateLanguagestorageKey
  }
}
